import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import cs from '../../img/cs.jpg'
import csscr from '../../img/csscr.jpg'
import csFont from '../../img/csFont.jpg'

function Cs() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title="Croatia Soundworks" />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="csDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={csFont} alt="Typescale" />
          <figcaption>Croatia Soundworks font</figcaption>
        </figure>
        <ul className='colors'>
          <li><span className='color' style={{background: "#232131"}}></span> #232131</li>
          <li><span className='color' style={{background: "#46425E"}}></span> #46425E</li>
          <li><span className='color' style={{background: "#29D9C4"}}></span> #29D9C4</li>
          <li><span className='color' style={{background: "#0EC6B0"}}></span> #0EC6B0</li>
          <li><span className='color' style={{background: "#25B1FF"}}></span> #25B1FF</li>
          <li><span className='color' style={{background: "#BABFCD"}}></span> #BABFCD</li>
          <li><span className='color' style={{background: "#F2F5F9"}}></span> #F2F5F9</li>
        </ul>

        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="csDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="csUXTxt" components={{ul: <ul />, li: <li />}}>
        The primary UX goal was to create an intuitive and engaging browsing experience while presenting complex audio production services in a clear and accessible way. The website structure was designed to guide users naturally through studio information, services, artist collaborations, and contact interactions without overwhelming the interface.
        <br /><br />Special attention was given to:
        <ul>
          <li>structured content hierarchy</li>
          <li>immersive visual presentation</li>
          <li>intuitive navigation flow</li>
          <li>clear service organization</li>
          <li>strong premium branding</li>
        </ul>
        The experience was designed to balance technical professionalism with an emotional and creative atmosphere inspired by modern music production studios.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="csVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={csscr} alt={t('figmaScr')} />
          <figcaption>{t('csScrCaption')}</figcaption>
        </figure>

        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="csFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://www.croatiasoundworks.com/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Cs

function ContentOne() {
  return(
    <img className="image-fluid" src={cs} alt="Croatia Soundworks" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('csMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://www.croatiasoundworks.com/"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
      <p className='problem'><Trans i18nKey="csMainTxt2">
        The main problem to solve was: <br/><i>How to best present a Croatian music studio with many years of history and many clients.</i>
      </Trans></p>
    </div>
  );
}